export default __webpack_public_path__ + "images/55aa190d48dbdbeeaccffb6783562faa.png";